import h from '../h';
export default function Labels(_ref) {
  var styles = _ref.styles,
      data = _ref.data,
      _onClick = _ref.onClick,
      rowHeight = _ref.rowHeight,
      offsetY = _ref.offsetY;
  return h("g", null, data.map(function (v, i) {
    return h("text", {
      key: i,
      x: 10,
      y: (i + 0.5) * rowHeight + offsetY,
      "class": "gantt-label",
      style: styles.label,
      onClick: function onClick() {
        return _onClick(v);
      }
    }, v.text);
  }));
}